import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import bannerService from "../../../services/bannerService";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const Banner = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await bannerService.getOneBanner(instanceToken.token, id);
        setBanner(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchBanner();
  }, [id]);

  const handleRemove = async () => {
    try {
      await bannerService.deleteBanner(instanceToken.token, id);
      homeAlert("Banner post have been removed.", false);
      navigate("/banners");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <DetailPageLayout
      title="Banner Details"
      subtitle="View and manage banner content"
      breadcrumbs={[
        { label: "Banners", path: "/banners" },
        { label: `Banner (ID - ${id})` },
      ]}
      listPath="/banners"
      imageUrl={banner?.image_url}
      loading={!banner}
      editPath={banner ? `/updateBanner/${banner.id}` : undefined}
      onRemove={handleRemove}
      contentSections={
        banner?.link
          ? [
              {
                title: "Link",
                value: banner.link,
                icon: "link",
              },
            ]
          : []
      }
      infoItems={
        banner
          ? [
              { label: "ID", value: String(banner.id), icon: "id" },
              { label: "Name (English)", value: banner.name_en, icon: "title" },
              {
                label: "Name (Myanmar)",
                value: banner.name_mm,
                icon: "title",
                myanmar: true,
              },
              { label: "Link", value: banner.link, icon: "link" },
              ...dateInfoItems(banner),
            ]
          : []
      }
      quickActions={
        banner?.link
          ? [
              {
                label: "Open Link",
                onClick: () => window.open(banner.link, "_blank", "noreferrer"),
              },
            ]
          : []
      }
    />
  );
};

export default Banner;
